var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLRepairIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6094 18.75C26.7891 18.75 30.9844 14.5547 30.9844 9.375C30.9844 8.47852 30.8555 7.61133 30.6211 6.78516C30.4395 6.15234 29.6602 6.01172 29.1973 6.47461L24.6973 10.9746C24.5215 11.1504 24.2812 11.25 24.0352 11.25H20.6719C20.1562 11.25 19.7344 10.8281 19.7344 10.3125V6.94922C19.7344 6.70312 19.834 6.46289 20.0098 6.28711L24.5098 1.78711C24.9727 1.32422 24.8262 0.544922 24.1992 0.363281C23.373 0.128906 22.5059 0 21.6094 0C16.4297 0 12.2344 4.19531 12.2344 9.375C12.2344 10.4941 12.4336 11.5723 12.791 12.5684L2.15039 23.209C1.40625 23.9531 0.984375 24.9668 0.984375 26.0215C0.984375 28.2188 2.76563 30 4.96289 30C6.01758 30 7.03125 29.5781 7.77539 28.834L18.416 18.1934C19.4121 18.5566 20.4902 18.75 21.6094 18.75ZM5.67188 23.9062C6.04484 23.9062 6.40252 24.0544 6.66624 24.3181C6.92997 24.5819 7.07812 24.9395 7.07812 25.3125C7.07812 25.6855 6.92997 26.0431 6.66624 26.3069C6.40252 26.5706 6.04484 26.7188 5.67188 26.7188C5.29891 26.7188 4.94123 26.5706 4.67751 26.3069C4.41378 26.0431 4.26562 25.6855 4.26562 25.3125C4.26562 24.9395 4.41378 24.5819 4.67751 24.3181C4.94123 24.0544 5.29891 23.9062 5.67188 23.9062Z",
    fill: "#059669"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLRepairIcon);
export default __webpack_public_path__ + "static/media/l_repair_icon.8def7516aa6685d6b0220e679d15913a.svg";
export { ForwardRef as ReactComponent };